import { z } from 'zod'

/**
 * 多筆查詢 Request Schema
 */
export const listRequestDataSchema = z.object({
  page: z.number().optional(),
  size: z.number().optional(),
  order: z.string().nullable().optional(),
  sort: z.string().nullable().optional()
})

/**
 * 多筆查詢 Request
 */
export interface ListRequestData
  extends z.infer<typeof listRequestDataSchema> {}
